import { UserDataType } from "../../types/interfaces";
import { ContextValueType } from "../context";

export const getUserData = (context: ContextValueType): UserDataType | null => {
  return context.userData;
};

export const setUserData = (
  context: ContextValueType,
  userData: UserDataType
) => {
  return context.setUserData(userData);
};
